var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('earth-layout',[_c('template',{slot:"A"},[_c('u-header',{attrs:{"title":_vm.$t('_.fraudmind')}},[_c('tabigation',{attrs:{"slot":"tabs","routes":_vm.routes()},slot:"tabs"})],1),_vm._v(" "),_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }